import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import RouteLineService from "../services/RouteLineService";

const useRouteLineService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new RouteLineService(client);
  }, [client]);

  return service;
};

export default useRouteLineService;
